import React from 'react';
import classNames from 'classnames';

type Props = {
  title: string;
  className?: string;
};

const TitleUndescore: React.FC<Props> = ({ title, className = '' }) => (
  <>
    {className === 'small' ? (
      <div className="title-underscore-small">
        <h4>{title}</h4>
        <span className={classNames(className, 'underscore')} />
      </div>
    ) : (
      <div className="title-underscore">
        <h4>{title}</h4>
        <hr className="underscore" />
      </div>
    )}
  </>
);

export default TitleUndescore;
